


































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import Loading from 'vue-loading-overlay';
import transitionServices from '@/services/transition-services';
import { TransitionModel } from '@/models/transition';
import ListTransition from './ListTransition.vue';
import Paging from '@/shared/components/Paging.vue';

@Component({
  components: {
    ListTransition,
    Loading,
    Paging
  },
})
export default class MainPackage extends Vue {
    private isLoading = false;
    private searchTerm = '';
    private searchResult: any = null;
    private listItem: TransitionModel[] = [];
    private pageSettings = {
        rowPerPage: 15,
        pageSize: 6,
        pageIndex: 1,
        total: 0,
    };

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get isDepositSystem() {
        return APP_CONFIG.system_type !== 'order';
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.searchTerm.length >= 8) {
            paramsFilter.filters.push({
                column: 'TransactionCode',
                value: this.searchTerm,
                condition: 'contain'
            });
        } else {
            paramsFilter.filters.push({
                column: 'TransactionCode',
                value: this.searchTerm,
                condition: 's_equal'
            });
        }

        return paramsFilter;
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }

    private async loadData() {
        if (this.searchTerm.trim() === '') {
            this.listItem = [];
            this.pageSettings.total = 0;
            return;
        }
        this.isLoading = true;
        this.searchResult = null;
        
        const filters: any = this.onBuildFilter();
        const result = await transitionServices.findList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        
        if (result && result.data && result.data.status === 200) {
            const tmpListTransition: TransitionModel[] = [];
            this.pageSettings.total = result.data.total;
            for (const item of result.data.data) {
                const transition = new TransitionModel();
                transition.ID = item.ID;
                transition.PackageType = item.PackageType;
                transition.Status = item.Status;
                transition.TransactionCode = item.TransactionCode;
                transition.OrderID = item.OrderID;
                transition.ReceiptID = item.ReceiptID;
                transition.Weight = item.Weight;
                transition.Length = item.Length;
                transition.Width = item.Width;
                transition.Height = item.Height;
                transition.Volume = item.Volume;
                transition.StoreCNImportDate = item.StoreCNImportDate;
                transition.StoreCNExportDate = item.StoreCNExportDate;
                transition.StoreVNImportDate = item.StoreVNImportDate;
                transition.StoreVNExportDate = item.StoreVNExportDate;
                transition.StoreDestImportDate = item.StoreDestImportDate;
                transition.StoreDestExportDate = item.StoreDestExportDate;
                transition.ProductName = item.ProductName;
                transition.ProductImage = item.ProductImage;
                transition.CreatedDate = item.CreatedDate;
                transition.OrderNote = item.OrderNote;
                transition.statusDetail = DATA.billOfLadingStatus.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };
                tmpListTransition.push(transition);
            }
            this.listItem = tmpListTransition;
        }
        this.isLoading = false;
    }
}
